import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { OkDialogComponent } from '../components/ok-dialog/ok-dialog.component';

@Injectable()
export class OkDialogService {

  constructor(
    private matDialog:MatDialog,
  ) {
  }



  show(html) {

    const dialogRef = this.matDialog.open(OkDialogComponent, {
      data: {html},
    });

  }
}


// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/services/ok-dialog.service.ts